export default "__VITE_ASSET__dLts65K88X0Og7JWtThTXA__"